import { Dispatch, SetStateAction, ChangeEvent } from "react";
import InfoTooltip from "../../../../components/Buttons/InfoTooltip";
import ConditionalSelectField from "../../../../components/Form/ConditionSelectField";
import SelectField from "../../../../components/Form/SelectFields";
import { EcleanCuration } from "../GenerateDSComponents/Curate";
import BooleanField from "../../../../components/Form/BooleanField";

export default function StandardizeSMILES({
    showSelect,
    form,
    setForm,
    fieldOptions,
    menuPortalTargetId,
    isSDF,
}: {
    showSelect: boolean,
    form: EcleanCuration,
    setForm: Dispatch<SetStateAction<EcleanCuration>>,
    fieldOptions: {
        value: string,
        label: string
    }[],
    menuPortalTargetId: string,
    isSDF: boolean,
}) {

    const handleSelectSmiles = (e:any, name: string) => {
        const value = e.value;

        form.eclean_std_smiles !== null && (
            setForm({
                ...form,
                eclean_std_smiles: {
                    ...form.eclean_std_smiles,
                    [name]: value,
                }
            })
        )
    };

    const handleBooleanSmiles = (e: ChangeEvent<HTMLInputElement>) => {
        const name = e.target.name;
        const value = e.target.checked;

        form.eclean_std_smiles !== null && (
            setForm({
                ...form,
                eclean_std_smiles: {
                    ...form.eclean_std_smiles,
                    [name]: value,
                }
            })
        )
    }

    return (
        <>
        {form.eclean_std_smiles !== null && (
            // Show standardize smiles fields if smiles string was not previously standardized
            <div className="flex flex-col gap-6 justify-start items-start">
                <div className="flex justify-start items-center gap-2">
                    <p className="text-default font-semibold">1. Standardize SMILES</p>
                    <InfoTooltip 
                        btnWidth="14px"
                        title="Standardize SMILES"
                        content={
                            <div className="flex flex-col gap-3 text-placeholder text-[12px]">
                                <p className="max-w-[300px]">This pipeline drops missing SMILES, canonicalizes SMILES, removes salts and solvents, handles fragments, charges, isotopes, stereogenesis, and tautomers, removes molecules with inorganic elements, and computes InChi keys.</p>
                            </div>
                        }
                    />
                </div>

                <div className="w-full flex justify-between items-end gap-4">
                    {!isSDF && // don't show this section if this is an SDF file. This field is hidden
                    // and set to 'sdf_molblock' by default
                        <ConditionalSelectField label='Original SMILES column' showSelect={showSelect}>
                            <SelectField 
                                label="Original SMILES column"
                                id="original_smiles_column"
                                name="original_smiles_column"
                                value={form.eclean_std_smiles.original_smiles_column ? {
                                    value: form.eclean_std_smiles.original_smiles_column,
                                    label: form.eclean_std_smiles.original_smiles_column
                                } : null}
                                options={fieldOptions}
                                isRequired={true}
                                isCreatable={false}
                                isMulti={false}
                                handleChange={handleSelectSmiles}
                                menuPortalTarget={document.getElementById(menuPortalTargetId)}
                            />
                        </ConditionalSelectField> 
                    }
                    <BooleanField 
                        label="Remove stereochemistry"
                        id="remove_stereo"
                        name="remove_stereo"
                        value={form.eclean_std_smiles.remove_stereo}
                        isRequired={false}
                        handleChange={handleBooleanSmiles}
                    />
                </div>
            </div>
        )}
        </>
    )
}